import { memo } from 'react';

import { type MessageUploadAttachment } from '@apps/web/components/phoebe_chat/transcript_types';
import {
    V3ChatAttachmentCard,
    type V3PresentationContext,
} from '@apps/web/features/phoebe_chat_v3';

export const V3UserUploadAttachmentCard = memo(
    function V3UserUploadAttachmentCard({
        upload,
        context,
    }: {
        readonly upload: MessageUploadAttachment;
        readonly context: V3PresentationContext;
    }) {
        return (
            <V3ChatAttachmentCard
                attachment={{
                    kind: 'chat-attachment',
                    version: 1,
                    runId: upload.runId,
                    attachmentId: upload.attachmentId,
                    filepath: upload.filename,
                    filename: upload.filename,
                    contentType: upload.contentType,
                    disposition: upload.disposition,
                    sizeBytes: upload.sizeBytes,
                }}
                context={context}
            />
        );
    },
);
